import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createOrgPromise, type CreateOrgParams } from 'src/utils';
import { useNotification } from 'src/hooks';
import { QUERY_KEY_MAP } from 'src/constants';

export const useCreateOrg = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: createOrgPromise,
  });

  const queryClient = useQueryClient();

  const { enqueueSuccessNotification, enqueueErrorNotification } = useNotification();

  const createOrgAsync = async (params: CreateOrgParams) => {
    try {
      const res = await mutateAsync(params);
      if (res) {
        enqueueSuccessNotification('Org created successfully');

        void queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_MAP.useGetManagementOrgs],
        });
      } else {
        enqueueErrorNotification('Error while creating org');
      }

      return res;
    } catch (e) {
      console.error('Error while creating org', e);
      enqueueErrorNotification('Error while creating org');

      return false;
    }
  };

  return {
    createOrgAsync,
    isLoading: isPending,
  };
};
